var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-book-open-page-variant",
      show: _vm.dialog,
      maxWidth: "40%",
      showButton: false,
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "tools",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c(
                          "v-alert",
                          {
                            attrs: {
                              border: "top",
                              "colored-border": "",
                              type: "info",
                              elevation: "2",
                            },
                          },
                          [
                            _vm.newItem
                              ? _c("span", [
                                  _vm._v(
                                    " Informe a data, horário e tipo de ocorrência "
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    " Selecione o tipo de ocorrência a ser cadastrada e justifique. "
                                  ),
                                ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.newItem
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("emc-clock-server-clock", {
                              ref: "serverClock",
                              attrs: { "auto-start": false },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.newItem
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("emc-calendar-date-picker2", {
                              attrs: {
                                model: _vm.newModel.date,
                                label: "Data*",
                                error: _vm.errors.length > 0,
                                "error-messages": _vm.errors.date,
                                show: _vm.dialog,
                                min: _vm.dateMin,
                                max: _vm.dateMax,
                                "allowed-dates": _vm.allowedDates,
                                dense: "",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(_vm.newModel, "date", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "3" } },
                          [
                            _c("s-text-field", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "00:00",
                                  expression: "'00:00'",
                                },
                              ],
                              attrs: {
                                dense: "",
                                clearable: "",
                                placeholder: "HH:MM",
                                rules: [_vm.validateTime],
                                "error-messages": _vm.errors.hour_start1,
                                label: "Início*",
                              },
                              model: {
                                value: _vm.newModel.hour_start1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newModel, "hour_start1", $$v)
                                },
                                expression: "newModel.hour_start1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "3" } },
                          [
                            _c("s-text-field", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "00:00",
                                  expression: "'00:00'",
                                },
                              ],
                              attrs: {
                                dense: "",
                                clearable: "",
                                placeholder: "HH:MM",
                                rules: [_vm.validateTime],
                                disabled:
                                  !_vm.newModel.hour_start1 &&
                                  !_vm.newModel.hour_end1,
                                "error-messages": _vm.errors.hour_end1,
                                label: "Fim*",
                              },
                              model: {
                                value: _vm.newModel.hour_end1,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newModel, "hour_end1", $$v)
                                },
                                expression: "newModel.hour_end1",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("sys-select-occurrence-type", {
                          attrs: {
                            model: _vm.newModel.occurrence_type_id,
                            label: "Tipo de Ocorrência*",
                            filterAdditional: _vm.newItem ? 1 : 0,
                            hideHolliday: "",
                            "show-description": "",
                            isTeacher: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.newModel,
                                "occurrence_type_id",
                                $event
                              )
                            },
                            change: _vm.changeType,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.selectedOccurrenceType && _vm.selectedOccurrenceType.link
                  ? _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "12", sm: "12" } }, [
                          _c(
                            "a",
                            {
                              attrs: { href: _vm.selectedOccurrenceType.link },
                            },
                            [_vm._v("Cadastrar Atestado - SOUANIMA")]
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedOccurrenceType &&
                _vm.selectedOccurrenceType.requires_motive
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c("sys-select-occurrence-motive", {
                              attrs: {
                                model:
                                  _vm.newModel
                                    .occurrence_sheet_register_motive_id,
                                label: "Motivo*",
                              },
                              on: {
                                "update:model": function ($event) {
                                  return _vm.$set(
                                    _vm.newModel,
                                    "occurrence_sheet_register_motive_id",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedOccurrenceType &&
                _vm.selectedOccurrenceType.occurrence_record_type_id == 1
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c("v-select", {
                              attrs: {
                                "item-value": "id",
                                "item-text": "name",
                                items: _vm.attributions,
                                label: "Selecione a UC",
                                dense: "",
                                "return-object": "",
                                loading: _vm.loadingAttribution,
                              },
                              model: {
                                value: _vm.attribution,
                                callback: function ($$v) {
                                  _vm.attribution = $$v
                                },
                                expression: "attribution",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedOccurrenceType &&
                _vm.selectedOccurrenceType.occurrence_record_type_id == 2 &&
                _vm.activities.length
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c("v-select", {
                              attrs: {
                                "item-value": "id",
                                "item-text": "name",
                                items: _vm.activities,
                                label: "Selecione a Atividade",
                                dense: "",
                                "return-object": "",
                                loading: _vm.loadingAttribution,
                              },
                              model: {
                                value: _vm.activityItem,
                                callback: function ($$v) {
                                  _vm.activityItem = $$v
                                },
                                expression: "activityItem",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _vm.newItem
                          ? _c("v-textarea", {
                              attrs: {
                                label:
                                  "Descrição (Mínimo " +
                                  _vm.minNote +
                                  "  caracteres)",
                                counter: _vm.maxNote,
                                rules: [
                                  (v) =>
                                    !v ||
                                    v.length <= _vm.maxNote ||
                                    "Máximo de " +
                                      _vm.maxNote +
                                      " caracteres atingido",
                                ],
                                outlined: "",
                                "aria-placeholder":
                                  "Informe uma descrição com no mínimo" +
                                  _vm.minNote +
                                  "caracteres",
                                error: _vm.errors.length > 0,
                                "error-messages": _vm.errors.description,
                              },
                              model: {
                                value: _vm.newModel.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newModel, "description", $$v)
                                },
                                expression: "newModel.description",
                              },
                            })
                          : _c("v-textarea", {
                              attrs: {
                                label:
                                  "Justificativa* (Mínimo " +
                                  _vm.minNote +
                                  "  caracteres)",
                                counter: _vm.maxNote,
                                rules: [
                                  (v) =>
                                    !v ||
                                    v.length <= _vm.maxNote ||
                                    "Máximo de " +
                                      _vm.maxNote +
                                      " caracteres atingido",
                                ],
                                outlined: "",
                                "aria-placeholder":
                                  "Informe uma justificativa com no mínimo" +
                                  _vm.minNote +
                                  "caracteres",
                                error: _vm.errors.length > 0,
                                "error-messages": _vm.errors.note,
                              },
                              model: {
                                value: _vm.newModel.note,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newModel, "note", $$v)
                                },
                                expression: "newModel.note",
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
            _c("emc-alert-modal", {
              attrs: {
                title: "Ocorrências de Ponto",
                icon: "mdi-book-open-page-variant",
                text: "Confirma o cadastro da ocorrência?",
                disabled: _vm.loading,
                show: _vm.showQuestion,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showQuestion = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", loading: _vm.loading },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v("Sim - Cadastrar")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "v-btn",
              {
                attrs: { color: "primary", disabled: _vm.disabledSave },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    _vm.showQuestion = true
                  },
                },
              },
              [
                _vm._v("Cadastrar Ocorrência"),
                _c("v-icon", { attrs: { right: "", dark: "" } }, [
                  _vm._v("mdi-calendar-minus"),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }